import React from "react";
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { reduxForm, Field } from "redux-form";

import TextField from "../form/TextField";
import Dialog from "./DialogWrap";
import * as Validation from "../form/Validation";

import {
  editUserResourceRights,
  getUserResourcesRights
} from "../../actions/resourceActions";

const AdminResourceEditRights = ({ handleSubmit, data }) => (
  <Dialog
    title="Upravit práva"
    name="AdminResourceEditRights"
    handleSubmit={handleSubmit}
    submitLabel="Upravit"
  >
    <Field
      component={TextField}
      label="Práva"
      name="rights"
      validate={[Validation.required]}
    />
  </Dialog>
);

export default compose(
  connect(
    ({ dialog: { data } }) => ({
      data,
      initialValues: data && data.right ? { rights: data.right.rights } : null
    }),
    { editUserResourceRights, getUserResourcesRights }
  ),
  withHandlers({
    onSubmit: dialog => async (formData, dispatch, props) => {
      const { editUserResourceRights, data, getUserResourcesRights } = props;
      const { rights } = formData;

      if (await editUserResourceRights({ ...data.right, rights })) {
        getUserResourcesRights(data.right.resource.id);
        dialog.closeDialog();
      }
    }
  }),
  reduxForm({
    form: "adminResourceEditRightsForm",
    enableReinitialize: true
  })
)(AdminResourceEditRights);



// WEBPACK FOOTER //
// ./src/components/dialogs/AdminResourceEditRights.js